import { render } from "./CapacityTool.vue?vue&type=template&id=e2870ed4"
import script from "./CapacityTool.vue?vue&type=script&lang=js"
export * from "./CapacityTool.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__